<template>
  <div>
    <p class="title" style="margin-bottom: 40px; font-weight: 500">Danh sách file đã được upload</p>
    <!-- Button Action -->
    <el-row type="flex" class="mt3" justify="space-between" align="bottom">
      <div class="el-pagination-size mt3">
        <span>Số bản ghi trên trang:&nbsp;</span>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            {{ search.pageSize }}
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in listPaginate"
              :key="item.key"
              :command="item.value"
            >{{ item.value }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-row>

    <el-card shadow="never" class="mt3" v-loading="loading">
      <!-- Table Data -->
      <el-table :data="data.data" style="width: 100%">
        <el-table-column property="id" label="ID" width="80"></el-table-column>
        <el-table-column property="original_file_name" label="Tên file"></el-table-column>
        <el-table-column property="signature" label="Chữ ký số"></el-table-column>
        <el-table-column property="uploader_name" label="Người upload"></el-table-column>
        <el-table-column property="uploaded_at" label="Thời gian upload">
          <template scope="scope">
            {{ scope.row.uploaded_at | formatDatetime }}
          </template>
        </el-table-column>
        <el-table-column label="Người ký">
          <template slot-scope="scope">
            <span class="signer-box">
              {{ getSignerName(scope.row.signature) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Thao tác" width="180">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="handleDownload(scope.row)"
              :loading="scope.row.downloading"
            >
              <i class="el-icon-download"></i>
            </el-button>
            <el-button
              type="info"
              size="mini"
              @click="handleViewDetail(scope.row.id)"
            >
              <i class="el-icon-view"></i> Chi tiết
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination -->
      <el-row type="flex" justify="space-between" align="middle" class="mt3" v-show="data.total">
        <div class="el-pagination-info">
          <span>Hiển thị {{ data.from }}-{{ data.to }} của {{ data.total }} bản ghi</span>
        </div>
        <el-pagination
          layout="prev, pager, next, jumper"
          :total="data.total"
          :current-page="data.current_page"
          :page-size="data.per_page"
          @current-change="handleChangePage"
        ></el-pagination>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import CONST from "@/config/const";
import CooperatorRequest from "../api/cooperator";
import moment from 'moment';

export default {
  name: "UploadHistory",
  data() {
    return {
      loading: false,
      search: {
        pageSize: CONST.PAGINATION[0].value,
      },
      data: {
        data: [],
        total: 0,
        current_page: 1,
        per_page: 25,
        from: 0,
        to: 0
      },
      listPaginate: CONST.PAGINATION,
      paramsSearch: {}
    };
  },
  methods: {
    async handleSearch() {
      this.loading = true;
      try {
        this.paramsSearch = {...this.search};
        const res = await CooperatorRequest.getUploadHistory(this.search);
        if (res.success) {
          this.data = res.data;
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    },

    async handleChangePage(page) {
      this.loading = true;
      try {
        const params = { ...this.paramsSearch, page: page };
        const res = await CooperatorRequest.getUploadHistory(params);
        if (res.success) {
          this.data = res.data;
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    },

    async handleCommand(command) {
      this.search.pageSize = command;
      this.paramsSearch.pageSize = command;
      this.loading = true;
      try {
        const res = await CooperatorRequest.getUploadHistory(this.paramsSearch);
        if (res.success) {
          this.data = res.data;
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    },

    async handleDownload(row) {
      this.$set(row, 'downloading', true);
      CooperatorRequest.downloadFile(row.id).then((res) => {
        this.downloadFile(res, row.original_file_name.replace('.pdf', ''), 'pdf');
        this.$set(row, 'downloading', false);
      })
      .catch((err) => {
        console.log(err);
        this.showError(err.response?.data?.message || "Có lỗi xảy ra khi kết xuất PDF");
        this.$set(row, 'downloading', false);
      });
    },

    getSignerName(signature) {
      if (!signature) return '';
      const match = signature.match(/CN=([^,]+)/);
      return match ? match[1].trim() : '';
    },

    handleViewDetail(fileId) {
      this.$router.push(`/admin/upload-history/${fileId}/detail`);
    }
  },
  async created() {    
    this.loading = true;
    try {
      this.paramsSearch = {...this.search};
      const res = await CooperatorRequest.getUploadHistory(this.search);
      if (res.success) {
        this.data = res.data;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    this.loading = false;
  }
};
</script>

<style lang="scss" scoped>
.el-form {
  .search-number {
    margin-top: 10px;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .search-request_type {
    .el-form-item {
      margin-bottom: 0px;
    }
  }
}
/deep/ .el-card__body {
  padding: 15px 20px;
}

.signature-box {
  background: #e6f7ff;
  color: #1890ff;
  border-radius: 4px;
  padding: 4px 8px;
  margin-bottom: 4px;
  display: inline-block;
  font-size: 13px;
  word-break: break-word;
}

.signer-box {
  display: inline-block;
  background: #e6ffed;
  color: #389e0d;
  border: 1px solid #b7eb8f;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
  margin: 2px 0;
}
</style>